<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col cols="12">
            <employee-search />
          </v-col>

          <v-col cols="12">
            <employee-table />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import EmployeeSearch from '@/components/people/employee/EmployeeSearch'
import EmployeeTable from '@/components/people/employee/EmployeeTable'

export default {
  components: {
    EmployeeSearch,
    EmployeeTable
  },

  data() {
    return {
      title: 'ค้นหาบุคลากร'
    }
  }
}
</script>
